const getters = {
  initialized: state => state.initialized,
  organisationList: state => state.organisationList,
  organisationListLastUpdateTime: state => state.organisationListLastUpdateTime,
  organisationListLoading: state => state.organisationListLoading,
  organisationNumbers: state => state.organisationNumbers,
  currentNumber: state => state.currentNumber,
  currentOrganisation: state => state.currentOrganisation,
  currentOrganisationBusinesses: state => state.currentOrganisation.businesses,
  currentOrganisationBusinessIds: state => state.currentOrganisationBusinessIds,
  getBusinessById: state => id => state.currentOrganisation.businesses.find(b => b.id === id),
  cloudApiSupport: (state) => {
    const numbers = {};
    state.currentOrganisation.businesses.forEach((b) => {
      numbers[b.id] = b.whatsapp.cloud_api;
    });
    return numbers;
  },
  currentOrganisationLoading: state => state.currentOrganisationLoading,
  currentOrganisationMembers: state => state.organisationMembers,
  currentOrganisationMembersLookup: state => state.organisationMembersLookup,
  getMemberById: state => id => ((id && state.organisationMembersLookup[id]) ? state.organisationMembersLookup[id] : {}),
  getMemberByPlatformId: state => id => state.organisationMembers.find(b => b.platform_id === id),
  currentOrganisationMembersLoading: state => state.organisationMembersLoading,
  currentOrganisationTeamsTree: state => state.currentOrganisationTeamsTree, // no longer valid!!!! @todo: remove
  currentOrganisationIntegrations: state => state.integrationsData,
  numberIntegrationMap: state => state.numberIntegrationMap,
  numberIntegrationData: state => state.numberIntegrationData,
  integrationsRegistryData: state => state.integrationsRegistryData,
  channelsDataRegistry: state => state.channelsDataRegistry,
  apiError: state => state.apiError,
  // logged-in user data, limited to organisation member scope
  me(state, getters, rootState, rootGetters) {
    const myID = rootGetters['user/id'];
    // console.log('getting me', myID, getters.getMemberById(myID));
    return getters.getMemberById(myID);
  },
  myAvailability(state, getters) {
    // const me = getters.me;
    // console.log('me is', me);
    // console.log('myAvailability is', me ? me.available : 'undefined!!!');
    // return me ? me.available : false; // ignoring me.online since this user is logged-in and online
    let myAvailability = false;
    if (
      getters.currentOrganisation &&
      getters.currentOrganisation.user_availability &&
      getters.currentOrganisation.user_availability.online &&
      getters.currentOrganisation.user_availability.available
    ) {
      myAvailability = getters.currentOrganisation.user_availability.online && getters.currentOrganisation.user_availability.available;
    }
    return myAvailability;
  },
  numberMembers: (state) => {
    const numberMembers = {};
    const orgMembersLookupIDs = Object.keys(state.organisationMembersLookup);
    if (orgMembersLookupIDs) {
      orgMembersLookupIDs.forEach((mId) => {
        const member = state.organisationMembersLookup[mId];
        member.businesses.forEach((numberId) => {
          if (numberMembers[numberId] && !numberMembers[numberId].includes(member.id)) {
            numberMembers[numberId].push(member.id);
          } else if (!numberMembers[numberId]) {
            numberMembers[numberId] = [member.id];
          }
        });
      });
    }

    return numberMembers;
  },
  showSplash: state => state.showSplash,
  splashMessage: state => state.splashMessage,
  splashTotal: state => state.splashTotal,
  finalizeSplash: state => state.finalizeSplash,
  statistics: state => state.statistics,
  statisticLocalData: state => state.statisticLocalData,
  organisationTeams: state => state.organisationTeams,
  reloadOrganisationList: state => state.reloadOrganisationList,
  updateBillingPage: state => state.updateBillingPage,
  forceResync: state => state.forceResync,
  progressActions: state => state.progressActions,
  totalUnreadConversations: state => state.totalUnreadConversations,
  localStatsOffsetCount: state => state.localStatsOffsetCount,
  localStatsOffsetIds: state => state.localStatsOffsetIds,
  localStatsOffsetMyChatCount: state => state.localStatsOffsetMyChatCount,
};

export default getters;
